import { cva } from 'class-variance-authority';
import { uiMarker, uiMarkerLayout } from './shared';

/**
 * ACTIVITY LOG, ON A PHONE
 *
 * The Call activity sheet (Figma 577:140196) draws its rules the sheet's
 * full width, through the 24px inset the sheet's body gives everything
 * else, and puts that inset back on each block between them. The list
 * reaches out to the edges and each block steps back in, so the rule runs
 * edge to edge while the words keep their margin.
 */
export const activityLogListRecipe = cva([
  uiMarker,
  uiMarkerLayout,
  '-mx-6 flex flex-col gap-4',
]);

/** One block between the rules: the sort, or one event. 16px apart inside. */
export const activityLogBlockRecipe = cva([
  uiMarker,
  uiMarkerLayout,
  'flex flex-col gap-4 px-6',
]);
